import { Navigate, useParams, generatePath } from 'react-router-dom';

export function OrderRedirect() {
  const { providerOrderId } = useParams<{ providerOrderId: string }>();
  return <Navigate to={generatePath('/orders/:providerOrderId', { providerOrderId: providerOrderId! })} replace />;
}
